import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Howler } from "howler";
import * as serviceworker from './serviceWorker';
import App from "./App";
import "./global.css"; // CSS global para remover scroll horizontal

// Blindagem do WebAudio e AudioContext para conformidade total com a Autoplay Policy do Chrome
if (typeof window !== "undefined") {
  // 1. Protege o método nativo AudioContext.prototype.resume
  // Impede que o Chrome emita "The AudioContext was not allowed to start. It must be resumed after a user gesture"
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (AudioContextClass && AudioContextClass.prototype) {
    const origResume = AudioContextClass.prototype.resume;
    AudioContextClass.prototype.resume = function () {
      if (this.state === "running") {
        return Promise.resolve();
      }
      if (navigator?.userActivation && !navigator.userActivation.hasBeenActive) {
        return Promise.resolve();
      }
      return origResume.apply(this, arguments).catch(() => {});
    };
  }

  // 2. Configuração do Howler
  if (typeof Howler !== "undefined" && Howler) {
    Howler.usingWebAudio = true;
    Howler.autoUnlock = false; // Desativa o hack legado de 2014 que disparava source.start(0) e ctx.resume() antes do tempo
    Howler._audioUnlocked = true; // Impede que o Howler tente recriar buffers fantasmas
    Howler.html5PoolSize = 100;

    // Desbloqueio suave e silencioso do AudioContext no primeiro gesto real do usuário
    const unlockAudio = (e) => {
      if (!e || (e.isTrusted && (!navigator?.userActivation || navigator.userActivation.hasBeenActive))) {
        if (Howler.ctx && Howler.ctx.state === "suspended") {
          Howler.ctx.resume().catch(() => {});
        }
      }
    };
    window.addEventListener("pointerdown", unlockAudio, { once: true, capture: true });
    window.addEventListener("keydown", unlockAudio, { once: true, capture: true });

    // Previne erro dummy em Howler._obtainHtml5Audio caso algum áudio HTML5 seja instanciado
    if (typeof Howler._obtainHtml5Audio === "function") {
      const origObtainHtml5Audio = Howler._obtainHtml5Audio;
      Howler._obtainHtml5Audio = function () {
        if (!Howler._html5AudioPool || Howler._html5AudioPool.length === 0) {
          const audioNode = new Audio();
          audioNode._unlocked = true;
          return audioNode;
        }
        return origObtainHtml5Audio.apply(this, arguments);
      };
    }
  }
}

// Previne aviso do Chrome/WAI-ARIA: "Blocked aria-hidden on an element because its descendant retained focus"
if (typeof window !== "undefined" && typeof Element !== "undefined") {
  const origSetAttribute = Element.prototype.setAttribute;
  Element.prototype.setAttribute = function (name, value) {
    if (name === "aria-hidden" && (value === "true" || value === true)) {
      if (
        this.contains &&
        document.activeElement &&
        document.activeElement !== document.body &&
        this.contains(document.activeElement)
      ) {
        try {
          document.activeElement.blur();
        } catch (e) {}
      }
    }
    return origSetAttribute.apply(this, arguments);
  };
}

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		// Remover a tela de carregamento quando o React terminar de renderizar
		setTimeout(() => {
			if (typeof window.finishProgress === 'function') {
				window.finishProgress();
			}
		}, 100);
	}
);

// Service Worker DESABILITADO - estava causando problemas:
// 1. Cache persistente em aba anônima
// 2. Socket não funcionando
// 3. Mensagens em tempo real não chegando
// serviceworker.register()
serviceworker.unregister()